import React, { Component } from 'react';
import { Tabs, Card } from 'antd';
import { BackBtn } from '@comm/BackBtn';
import DateCondition from '@comm/search/DateSearch';
import { connect } from 'react-redux';
import { getExpendType } from '@store/modules/finance/expend_type';
import { getIncomeType } from '@store/modules/finance/income_type';
import TabDetail from './TabDetail';
import TabChart from './TabChart';
import '../analyze.less';

const { TabPane } = Tabs;
class IncomeIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(getExpendType()); // 资金流水列表需要类目
    dispatch(getIncomeType());
  }

  handleChange = params => {
    this.setState({
      condition: { ...params },
    });
  };

  render() {
    const { condition } = this.state;
    const { year } = this.props.location.query;
    return (
      <div>
        <BackBtn />
        <Tabs
          defaultActiveKey="1"
          onChange={this.callback}
          tabBarExtraContent={
            <DateCondition
              onChange={this.handleChange}
              defaultValue={{
                beginDate: `${year}-01-01`,
                endDate: `${year}-12-31`,
              }}
            />
          }
        >
          <TabPane tab="总收入" key="1">
            <Card>
              <TabChart {...this.props} condition={condition} />
            </Card>
          </TabPane>
          <TabPane tab="详情" key="2">
            <TabDetail {...this.props} condition={condition} />
          </TabPane>
        </Tabs>
      </div>
    );
  }
}
export default connect(state => ({
  expendType: state.expend_type,
  incomeType: state.income_type,
}))(IncomeIndex);



// WEBPACK FOOTER //
// ./src/components/finance/budget/balance/income/Index.js